'use client';

import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import theme from '@/app/ui/css/theme';


export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles 
        styles={(theme) => ({
          ':root': {
            '--cor-primaria': theme.palette.primary.main,
          },
        })} 
      />
      {children}
    </ThemeProvider>
  );
}